import { ButtonProps } from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useMemo } from "react";
import { Dialog } from "../Dialog";
import SuccessIcon from "../../assets/campaign/success.png";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";

type DialogSuccessCampaignProps = {
  open: boolean;
  onClose: () => void;
};

export function DialogSuccessCampaign({
  open,
  onClose,
}: DialogSuccessCampaignProps) {
  const navigate = useNavigate();
  const actions: ButtonProps[] = useMemo(() => {
    return [
      {
        children: "Criar nova campanha",
        onClick: onClose,
      },
      {
        variant: "contained",
        children: "Campanhas",
        onClick: () => {
          navigate("/campaign");
        },
      },
    ];
  }, [navigate, onClose]);
  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      title="Campanha concluída"
      open={open}
      actions={actions}
    >
      <Typography color="GrayText">
        Estamos organizando sua campanha para sair como planejado.
      </Typography>
      <Stack marginY={1} alignItems="center">
        <img alt="success" src={SuccessIcon} />
      </Stack>
    </Dialog>
  );
}
